// import { Button, Card, DatePicker, Form, Input, message, Select } from "antd";
// import dayjs from "dayjs";
// import React, { useEffect, useState } from "react";
// import { CiSearch } from "react-icons/ci";
// import { useSelector } from "react-redux";
// import PageHeaders from "../../components/pageHeaders";
// import { API } from "../../config/Api";
// import { POST } from "../../utils/apiRequest";
// import DataTable from "./dataTable";
// import LoadingBox from "../../components/loadingBox";

// const Attendance: React.FC = () => {
//   const [form] = Form.useForm();
//   const [loading, setLoading] = useState(false);
//   const [attendance, setAttendance] = useState([]);
//   const [selectedDate, setSelectedDate] = useState<any>(dayjs());
//   const User = useSelector((state: any) => state?.User?.user);

//   const [searchState, setSearchState] = useState({
//     query: "",
//     page: 1,
//     pageSize: 20,
//     attendanceStatus: "Presents",
//   });

//   const getAttendance = async () => {
//     try {
//       setLoading(true);

//       const { query, attendanceStatus } = searchState;
//       const date = selectedDate.format("YYYY-MM-DD");
//       const month = selectedDate.month() + 1;
//       const year = selectedDate.format("YYYY");

//       const body = {
//         id: User?.office?.id,
//         filter: attendanceStatus,
//         search: query,
//         date,
//         month,
//         year,
//       };

//       const response: any = await POST(API.ATTENDANCE, body);

//       if (response?.status) {
//         setAttendance(response?.data || []);
//       } else {
//         message.error(response.data?.message || "Failed to fetch attendance");
//       }
//     } catch (error) {
//       console.error(error);
//       message.error("An error occurred while fetching attendance");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     getAttendance();
//   }, [selectedDate, searchState]);

//   const clearFilters = () => {
//     setSearchState({
//       query: "",
//       page: 1,
//       pageSize: 20,
//       attendanceStatus: "Presents",
//     });
//     form.resetFields(["query", "attendanceStatus"]);
//   };

//   const handleSearchChange = (e: any) => {
//     setSearchState((prev) => ({ ...prev, query: e.target.value, page: 1 }));
//   };

//   const handleDateChange = (date: any | null) => {
//     setSelectedDate(date ? date : dayjs());
//   };

//   const handleStatusChange = (value: string) => {
//     setSearchState((prev) => ({ ...prev, attendanceStatus: value, page: 1 }));
//   };

//   return (
//     <div>
//       <PageHeaders title="Attendance" breadcrumb="Attendance">
//         <Form
//           form={form}
//           layout="inline"
//           initialValues={{
//             attendanceStatus: "Presents",
//             date: selectedDate,
//           }}
//         >
//           <div className="d-flex flex-column flex-wrap flex-sm-row ">
//             <Form.Item name="query">
//               <Input
//                 style={{ width: 200 }}
//                 placeholder="Search name or phone etc ..."
//                 allowClear
//                 suffix={<CiSearch size={16} />}
//                 onChange={handleSearchChange}
//               />
//             </Form.Item>

//             <Form.Item name="date">
//               <DatePicker
//                 style={{ width: 200 }}
//                 onChange={handleDateChange}
//                 format="YYYY/MM/DD"
//                 value={selectedDate}
//               />
//             </Form.Item>

//             <Form.Item name="attendanceStatus">
//               <Select style={{ width: 200 }} onChange={handleStatusChange}>
//                 <Select.Option value="Presents">Present</Select.Option>
//                 <Select.Option value="Absents">Absent</Select.Option>
//               </Select>
//             </Form.Item>

//             <Button onClick={clearFilters}>Clear Filters</Button>
//           </div>
//         </Form>
//       </PageHeaders>
//       <div className="screenBox">
//         <Card>
//           <h5 className="user-heading">
//             {searchState?.attendanceStatus} ({attendance?.length})
//           </h5>
//           {loading ? (
//             <LoadingBox />
//           ) : (
//             <DataTable
//               data={attendance}
//               filter={searchState?.attendanceStatus}
//             />
//           )}
//         </Card>
//       </div>
//     </div>
//   );
// };

// export default Attendance;

import { Button, Card, DatePicker, Form, Input, message, Select } from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { CiSearch } from "react-icons/ci";
import { useSelector } from "react-redux";
import PageHeaders from "../../components/pageHeaders";
import { API } from "../../config/Api";
import { POST } from "../../utils/apiRequest";
import DataTable from "./dataTable";
import LoadingBox from "../../components/loadingBox";

const Attendance: React.FC = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [attendance, setAttendance] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedDate, setSelectedDate] = useState<any>(dayjs());
  const User = useSelector((state: any) => state?.User?.user);

  const [searchState, setSearchState] = useState({
    query: "",
    page: 1,
    pageSize: 20,
    attendanceStatus: "Presents",
  });

  const getAttendance = async () => {
    try {
      setLoading(true);

      const { query, attendanceStatus, page, pageSize } = searchState;
      const date = selectedDate.format("YYYY-MM-DD");
      const month = selectedDate.month() + 1;
      const year = selectedDate.format("YYYY");

      const body = {
        id: User?.office?.id,
        filter: attendanceStatus,
        search: query,
        date,
        month,
        year,
        page,
        pageSize,
      };

      const response: any = await POST(API.ATTENDANCE, body);

      if (response?.status) {
        setAttendance(response?.data || []);
        // If the API returns total count, use it
        if (response?.totalCount !== undefined) {
          setTotalCount(response.totalCount);
        } else {
          // Otherwise use the length of the data array
          setTotalCount(response?.data?.length || 0);
        }
      } else {
        message.error(response.data?.message || "Failed to fetch attendance");
      }
    } catch (error) {
      console.error(error);
      message.error("An error occurred while fetching attendance");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAttendance();
  }, [selectedDate, searchState]);

  const clearFilters = () => {
    setSearchState({
      query: "",
      page: 1,
      pageSize: 20,
      attendanceStatus: "Presents",
    });
    form.resetFields(["query", "attendanceStatus"]);
  };

  const handleSearchChange = (e: any) => {
    setSearchState((prev) => ({ ...prev, query: e.target.value, page: 1 }));
  };

  const handleDateChange = (date: any | null) => {
    setSelectedDate(date ? date : dayjs());
  };

  const handleStatusChange = (value: string) => {
    setSearchState((prev) => ({ ...prev, attendanceStatus: value, page: 1 }));
  };

  const handlePageChange = (page: number, pageSize: number) => {
    setSearchState(prev => ({
      ...prev,
      page,
      pageSize
    }));
  };

  return (
    <div>
      <PageHeaders title="Attendance" breadcrumb="Attendance">
        <Form
          form={form}
          layout="inline"
          initialValues={{
            attendanceStatus: "Presents",
            date: selectedDate,
          }}
        >
          <div className="d-flex flex-column flex-wrap flex-sm-row ">
            <Form.Item name="query">
              <Input
                style={{ width: 200 }}
                placeholder="Search name or phone etc ..."
                allowClear
                suffix={<CiSearch size={16} />}
                onChange={handleSearchChange}
              />
            </Form.Item>

            <Form.Item name="date">
              <DatePicker
                style={{ width: 200 }}
                onChange={handleDateChange}
                format="YYYY/MM/DD"
                value={selectedDate}
              />
            </Form.Item>

            <Form.Item name="attendanceStatus">
              <Select style={{ width: 200 }} onChange={handleStatusChange}>
                <Select.Option value="Presents">Present</Select.Option>
                <Select.Option value="Absents">Absent</Select.Option>
              </Select>
            </Form.Item>

            <Button onClick={clearFilters}>Clear Filters</Button>
          </div>
        </Form>
      </PageHeaders>
      <div className="screenBox">
        <Card>
          <h5 className="user-heading">
            {searchState?.attendanceStatus} ({totalCount})
          </h5>
          {loading ? (
            <LoadingBox />
          ) : (
            <DataTable
              data={attendance}
              filter={searchState?.attendanceStatus}
              current={searchState.page}
              pageSize={searchState.pageSize}
              total={totalCount}
              onPageChange={handlePageChange}
            />
          )}
        </Card>
      </div>
    </div>
  );
};

export default Attendance;